<template>
   <footer>
      <div class="footer">created by 
         <a class="github" href="https://github.com/matiussi" target="_blank">Matiussi</a> - <a href="https://devchallenges.io/" target="_blank">devChallenges.io</a> 
      </div>
   </footer>
</template>

<script>
export default {
   name: 'Footer'
}
</script>

<style>

</style>